import {useAppSelector} from 'hooks'

import {useAppDispatch} from 'store'

import {FetchListOrgCanSellProductRequest} from 'api/productApi'
import {
  changeQuerySearch,
  handleGetListOrgCanSellProduct,
  resetQuery,
  selectError,
  selectListOrgCanRegister,
  selectLoading,
  selectQuery,
  selectTotalPages,
} from './orgLicenseRegisterSlice'

export default function useOrgLicenseRegister() {
  const dispatch = useAppDispatch()
  const loading = useAppSelector(selectLoading)
  const error = useAppSelector(selectError)
  const query = useAppSelector(selectQuery)
  const listOrgCanRegister = useAppSelector(selectListOrgCanRegister)

  const totalPages = useAppSelector(selectTotalPages)

  const onSearch = (payload: FetchListOrgCanSellProductRequest) => {
    try {
      dispatch(handleGetListOrgCanSellProduct(payload))
    } catch (error) {
      console.error('Update URLSearchParams failed', error)
    }
  }
  const changeQuery = (
    key: keyof typeof query,
    value: (typeof query)[typeof key],
  ) => {
    dispatch(changeQuerySearch({key, value}))
  }

  const resetQuerySearch = () => {
    dispatch(resetQuery())
  }

  return {
    loading,
    query,
    error,
    listOrgCanRegister,
    totalPages,
    onSearch,
    changeQuery,
    resetQuerySearch,
  }
}
